import React from 'react';
import svg from 'shared/assets/icons/sprites/carCard.svg';

const CarIcon = () =>
  <svg width="12" height="12">
    <use xlinkHref={`${svg}#car`} />
  </svg>;

export default CarIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/CarIcon.js